import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
// import { formatDate } from './formatters';

export const ZakljucneOcjenePredmetaTable = (props) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(15);

/*     const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };*/

/*     const formatDate = (value) => {
      console.log(" >>>> formatDate value: " + value);
        return value.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }; */
    const dateBodyTemplate = (rowData) => {
      const date = new Date(rowData.datum_ispita);
      // console.log(" >>>> dateBodyTemplate rowData: " + rowData);
      // console.log(" >>>> dateBodyTemplate rowData.datum_ispita: " + rowData.datum_ispita);
      // console.log(" >>>> date: " + date);
      // console.log(" >>>> Intl.DateTimeFormat(hr-HR): " + new Intl.DateTimeFormat("hr-HR").format(date));
        // return formatDate(rowData.datum_ispita);
      return new Intl.DateTimeFormat("hr-HR").format(date);
    };
/*     const dateTemplate = (rowData, column) => {
      return rowData['datum_ispita'].toLocaleDateString();
    }; */

  const onCustomPage = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 15, value: 15 },
      ];

      return (
        <React.Fragment>
          <span
            className="mx-1"
            style={{ color: "var(--text-color)", userSelect: "none" }}
          >
            Zapisa po stranici:{" "}
          </span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </React.Fragment>
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span
          style={{
            color: "var(--text-color)",
            userSelect: "none",
            width: "120px",
            textAlign: "center",
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      );
    },
  };

  return (
    <div className="centerText">
      <DataTable
        value={props.data}
        stripedRows
        paginator
        paginatorTemplate={paginatorTemplate}
        first={first}
        rows={rows}
        onPage={onCustomPage}
        paginatorClassName="justify-content-end"
        responsiveLayout="scroll"
      >
        <Column
          field="naziv_predmeta"
          header="Predmet"
          className="table-column-default"
        ></Column>
        <Column
          field="datum_ispita"
          header="Datum ispita"
          className="table-column-date"
          dataType="date"
          body={dateBodyTemplate}
          // body={dateBodyTemplate}
          // body={dateTemplate}
          dateFormat="d/*  */d/mm/yy"
        ></Column>
        <Column
          field="zakljucna_ocjena"
          header="Zaključna ocjena"
          className="table-column-grade"
        ></Column>
      </DataTable>
    </div>
  );
};

export default ZakljucneOcjenePredmetaTable;
